/**
 * 规范化安装包下载地址（相对路径、缺协议域名等）
 */
export function normalizeClientDownloadUrl(href) {
  if (href == null || href === "") {
    return "";
  }
  let u = String(href).trim();
  if (!u || u === "#") {
    return "";
  }
  if (/^https?:\/\//i.test(u)) {
    return u;
  }
  if (u.startsWith("//")) {
    return `${window.location.protocol}${u}`;
  }
  if (u.startsWith("/var/www/html/file/mac/version/")) {
    return `https://cloud.wird.com.cn/file/mac/version/${u.slice("/var/www/html/file/mac/version/".length)}`;
  }
  if (u.startsWith("/var/www/html/file/ios/version/")) {
    return `https://cloud.wird.com.cn/file/ios/version/${u.slice("/var/www/html/file/ios/version/".length)}`;
  }
  if (u.startsWith("/var/www/html/file/qt/version/")) {
    return `https://cloud.wird.com.cn/file/qt/version/${u.slice("/var/www/html/file/qt/version/".length)}`;
  }
  if (u.startsWith("/var/www/html/file/apk/version/")) {
    return `https://cloud.wird.com.cn/file/apk/version/${u.slice("/var/www/html/file/apk/version/".length)}`;
  }
  if (u.startsWith("/")) {
    return `${window.location.origin}${u}`;
  }
  if (/^[a-z0-9.-]+\.[a-z]{2,}(\/|$)/i.test(u)) {
    return `https://${u.replace(/^\/+/, "")}`;
  }
  return `${window.location.origin}/${u.replace(/^\/+/, "")}`;
}

/**
 * 触发浏览器下载/打开安装包（避免 window.open 被拦截后点击穿透导致页面刷新）
 */
export function triggerClientDownload(href, fileName) {
  const url = normalizeClientDownloadUrl(href);
  if (!url) {
    return false;
  }
  const a = document.createElement("a");
  a.href = url;
  a.target = "_blank";
  a.rel = "noopener noreferrer";
  if (fileName) {
    a.setAttribute("download", fileName);
  }
  a.style.display = "none";
  document.body.appendChild(a);
  a.click();
  document.body.removeChild(a);
  return true;
}
